module.exports = __webpack_public_path__ + "img/film_bas.5954147c.png";